const ChartOfAccountsActionTypes = {
  SET_GROUPS: 'SET_GROUPS',
  SET_LEDGER_CATEGORIES: 'SET_LEDGER_CATEGORIES',
  REMOVE_LEDGER_CATEGORY: 'REMOVE_LEDGER_CATEGORY',
  SET_LEDGER_ACCOUNTS: 'SET_LEDGER_ACCOUNTS',
  REMOVE_LEDGER_ACCOUNT: 'REMOVE_LEDGER_ACCOUNT',
};

export default ChartOfAccountsActionTypes;
